<!--
PvcPostcard
PVC明信片
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌 > PVC明信片" name="PVC明信片">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="pvcPostcard" label-width="80px">
              <el-form-item label="形状">
                <el-select v-model="pvcPostcard['形状']" placeholder="形状">
                  <el-option label="尖角" value="尖角"></el-option>
                  <el-option label="圆角" value="圆角"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-select v-model="pvcPostcard['工艺']" placeholder="请选择制作工艺">
                  <el-option label="烫金" value="烫金" name="type"></el-option>
                  <el-option label="烫银" value="烫银" name="type"></el-option>
                  <el-option label="镭射银" value="镭射银" name="type"></el-option>
                  <el-option label="无工艺（默认表面覆膜）" value="无工艺（默认表面覆膜）" name="type"></el-option>
                  <el-option label="透明部分（默认表面覆膜）" value="透明部分（默认表面覆膜）" name="type"></el-option>
                </el-select>
                <div style="padding:10px"></div>
                <el-alert title="其他工艺请联系客服" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 0 0 0 0;"></el-alert>
              </el-form-item>
              <!---->
              <el-form-item label="尺寸">
                <el-radio-group v-model="pvcPostcard['尺寸']">
                  <el-radio-button label="9.8*15cm">9.8*15cm</el-radio-button>
                  <el-radio-button label="自定义尺寸">自定义尺寸</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="自定义尺寸" v-if="pvcPostcard['尺寸']=='自定义尺寸'">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="pvcPostcard['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="pvcPostcard['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <!---->
              <el-form-item label="款式">
                <el-input v-model="pvcPostcard['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="pvcPostcard['数量']" :min="500" label="数量"></el-input-number>
              <el-alert title="单款起定数为500" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PvcPostcard",
  data() {
    return {
      forcollapse: ['allsame'],
      pvcPostcard: {
        title: "PVC明信片",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.pvcPostcard);
       
    },
    clear() {
      this.$root.clearAlert()
      this.pvcPostcard = {
        title: "PVC明信片",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>